import { db, type OfflineAction } from './db';
import { api } from './api';

export class SyncManager {
  private isProcessing = false;
  private onSyncStatusChange: (status: 'SYNCING' | 'IDLE' | 'ERROR') => void;

  constructor(onSyncStatusChange: (status: 'SYNCING' | 'IDLE' | 'ERROR') => void) {
    this.onSyncStatusChange = onSyncStatusChange;
    
    // Écouter le retour de la connexion
    window.addEventListener('online', () => {
      console.log("🌐 Connexion rétablie. Lancement de la synchronisation...");
      this.sync();
    });
  }

  async sync() {
    if (this.isProcessing) return;
    
    const actions = await db.actionsQueue.toArray();
    if (actions.length === 0) return;

    console.log(`🔄 Synchronisation de ${actions.length} actions en cours...`);
    this.isProcessing = true;
    this.onSyncStatusChange('SYNCING');

    for (const action of actions) {
      try {
        await this.processAction(action);
        await db.actionsQueue.delete(action.id!);
        console.log(`✅ Action ${action.type} synchronisée.`);
      } catch (err) {
        console.error(`❌ Échec de synchronisation pour ${action.type}:`, err);
        // On s'arrête si erreur réseau pour ne pas boucler inutilement
        if (!window.navigator.onLine) break;
      }
    }

    this.isProcessing = false;
    const remaining = await db.actionsQueue.count();
    this.onSyncStatusChange(remaining === 0 ? 'IDLE' : 'ERROR');
  }

  private async processAction(action: OfflineAction) {
    const { type, params } = action;
    const token = params.token || localStorage.getItem('atelier_bassoum_token');

    switch (type) {
      case 'createCommande':
        return await api.createCommande(token, params.commandeData);
      case 'createVente':
        return await api.createVente(token, params.venteData);
      case 'createStock':
        return await api.createStock(token, params.stockData);
      case 'updateStock':
        return await api.updateStock(token, params.id, params.stockData);
      case 'addCommandePaiement':
        return await api.addCommandePaiement(token, params.id, params.data);
      default:
        console.warn(`Type d'action inconnu: ${type}`);
    }
  }
}
